export const HorarioConfig = {
    inicio: 10, // Hora de inicio (08:00)
    fin: 20,   // Hora de fin (17:59)
};

export const DireccionConfig = {
    direccion: "H58C+R6, Siguatepeque, Siguatepeque, Departamento de Comayagua, Honduras, 12111",
    longitud: -87.82941172024013,
    latitud: 14.567054203377594,
};

export const NegocioConfig = {
    sistema: "ARESSA",
    nombre: "GRUPO ARESSA",
    rtn: "03189024607376",
    direccion: "Carretera  Ca-5, 500 mts antes de la estacion de peaje Siguatepeque, Comayagua",
    telefono: "92866696 96692227 93407966",
    logo: "/logoAressa2.png",
    facturaPrefix: "000-001-01",
    correo:"Grupoaressa23@gmail.com"
};

export const permisosPorRuta = {
    "Empleados": { ruta: "/app/admin/empleados/", permisos: ["Nuevo", "Buscar", "Gestionar", "Accesos", "Cargos"] },
    "Productos": { ruta: "/app/admin/productos/", permisos: ["Nuevo", "Buscar", "Gestionar", "Tipos"] },
    "Clientes": { ruta: "/app/admin/clientes/", permisos: ["Nuevo", "Buscar", "Gestionar", "Auto"] },
    "Pedidos": { ruta: "/app/admin/pedidos/", permisos: ["Nuevo", "Buscar", "Gestionar"] },
    "Ventas": { ruta: "/app/admin/ventas/", permisos: ["Nuevo", "Gestionar", "Credito", "Ver"] },
    "Cajeros": { ruta: "/app/admin/cajeros/", permisos: ["Apertura", "Cierre", "BuscarCierre", "BuscarApertura", "BuscarPagos", "IngresosEgresos"] },
    "Compras": { ruta: "/app/admin/compras/", permisos: ["Nuevo", "Gestionar", "Credito"] },
    "Proveedores": { ruta: "/app/admin/proveedores/", permisos: ["Nuevo", "Buscar", "Gestionar"] },
    "Inventarios": { ruta: "/app/admin/inventarios/", permisos: ["Nuevo", "Gestionar", "Tipos"] },
    "Cotizaciones": { ruta: "/app/admin/cotizaciones/", permisos: ["Nuevo", "Gestionar"] },
    "Lotes": { ruta: "/app/admin/lotes/", permisos: ["Gestionar", "Asignar"] },
    "Planillas": { ruta: "/app/admin/planillas/", permisos: ["Gestion", "Generar"] },
    "Analisis": { ruta: "/app/admin/analisis/", permisos: ["Ventas", "Clientes", "Compras", "Productos", "Empleados", "Productos","Cajas"] },
};